import { useEffect } from 'react'
import CustomHead from 'components/commons/CustomHead'
import Button from 'components/commons/Button/Button'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

const Custom404: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])

  return (
    <>
      <CustomHead
        keyword="UI/UXデザイン UIデザイン UXデザイン アプリ開発 生成AI クラウド基盤構築"
        image="https://www.i3design.jp/OGP_logo.png"
        url="https://www.i3design.jp/404/"
        title="お探しのページが見つかりません | i3DESIGN アイスリーデザイン"
        description="一時的にアクセスできない状況にあるか、移動もしくは削除された可能性があります。"
      />
      <div className="notfound">
        <h1 className="notfound_ttl">
          <span className="notfound_ttl_en">404 Not found</span>
          <span className="notfound_ttl_ja">お探しのページが見つかりません</span>
        </h1>
        <p className="notfound_text">
          一時的にアクセスできない状況にあるか<span className="notfound_text_pc">、</span>
          <br className="notfound_text_sp" />
          移動もしくは削除された可能性があります。
        </p>
        <div className="notfound_btn">
          <Button text="トップページへ" href="/"></Button>
        </div>
      </div>
      <div style={{ backgroundColor: '#f8f7f2' }}>
        <MailmagazineLink />
      </div>
    </>
  )
}

export default Custom404
